import { render, staticRenderFns } from "./USA.vue?vue&type=template&id=2d44de5c&scoped=true&"
import script from "./USA.vue?vue&type=script&lang=js&"
export * from "./USA.vue?vue&type=script&lang=js&"
import style0 from "./USA.vue?vue&type=style&index=0&id=2d44de5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44de5c",
  null
  
)

export default component.exports